/** Namespace `integrationRoutes` — bản gốc tiếng Việt (PLAT-2026-135 lát W · ADR-038). Khoá phẳng; `{biến}` để chèn. */
export const integrationRoutes = {
  routeSummary: "Ứng dụng gửi qua tuyến chính; tuyến dự phòng chỉ nhận thư khi đáp ứng điều kiện chuyển tuyến.",
  validationProcess: "Quy trình kiểm trước khi dùng tuyến",
  configureEmail: "Cấu hình nhà cung cấp email",

  sections: "Thiết lập tuyến email",
  routesTab: "Tuyến gửi",
  policyTab: "Chính sách",
  historyTab: "Lịch sử",

  title: "Tuyến gửi mail",
  subtitle:
    "App gửi qua tuyến CHÍNH; dự phòng « ấm » (đã qua cổng kiểm, còn hạn) là đích tự chuyển khi tuyến chính hỏng chắc chắn. Mọi lần chọn / thêm tuyến đi qua cổng kiểm 4 bước: tiền kiểm tài khoản → app áp dụng bộ tuyến → app gửi THẬT một thư kiểm → nhà cung cấp báo đã giao.",
  loading: "Đang tải bộ tuyến…",
  loadFailed: "Không đọc được bộ tuyến.",
  empty: "App chưa có tuyến nào từ hub — app đang gửi bằng cấu hình cũ (env) hoặc chưa gửi được. Thêm tuyến chính bên dưới.",
  noRecipient: "Hub chưa khai HQ_MAIL_VALIDATION_RECIPIENT (hộp thư nhận thư kiểm) — cổng kiểm sẽ dừng ở bước gửi thử.",
  versions: "Bộ tuyến v{version}",
  "col.route": "Tuyến",
  "col.state": "Trạng thái",
  "col.gate": "Cổng kiểm",
  "role.primary": "Chính",
  "role.standby": "Dự phòng",
  "role.disabled": "Tắt",
  "traffic.eligible": "nhận thư",
  "traffic.validation_only": "chỉ để kiểm",
  "status.confirmed": "đã qua cổng kiểm",
  "status.grandfathered_primary": "chưa kiểm (có từ trước)",
  "status.failed": "kiểm hỏng",
  "status.pending": "đang chờ kiểm",
  warm: "ấm tới {at}",
  notWarm: "không « ấm » — không là đích tự chuyển",
  scope: "phạm vi giao {scope}",
  credentialVersion: "cấu hình gửi v{version}",
  "gate.running": "đang chạy",
  "gate.passed": "đạt",
  "gate.failed": "hỏng",
  "gate.target.primary": "đặt làm chính",
  "gate.target.standby": "thêm dự phòng",
  "gate.target.revalidate": "tái kiểm",
  "gate.by": "{target} · {actor} · {at}",
  "step.precheck": "Tiền kiểm",
  "step.stage": "App áp dụng",
  "step.app_test": "Gửi thử",
  "step.confirm": "Đã giao",
  "step.activate": "Kích hoạt",
  "reason.set_missing": "không còn bộ thông số",
  "reason.decrypt_failed": "hub không giải mã được bộ",
  "reason.account_no_key": "bộ chưa có khoá quản trị",
  "reason.account_error": "không đọc được tài khoản nhà cung cấp",
  "reason.account_never": "chưa đọc được tài khoản",
  "reason.account_decrypt_failed": "hub không giải mã được bộ",
  "reason.account_shutdown": "tài khoản bị khoá gửi",
  "reason.sending_disabled": "tài khoản đang tắt gửi",
  "reason.sandbox": "tài khoản đang ở sandbox",
  "reason.quota_exhausted": "hạn mức đã chạm trần",
  "reason.from_invalid": "địa chỉ gửi không phải email hợp lệ",
  "reason.settings_invalid": "thiết lập tuyến có trường lạ",
  "reason.from_missing": "tuyến chưa có địa chỉ gửi",
  "reason.from_domain_unverified": "domain của địa chỉ gửi chưa xác minh",
  "reason.webhook_not_active": "webhook sự kiện giao thư chưa nhận — nối webhook ở trang nhà cung cấp",
  "reason.app_not_applied": "app chưa áp dụng bộ tuyến mới trong 10 phút",
  "reason.no_validation_recipient": "hub chưa khai hộp thư nhận thư kiểm",
  "reason.no_delivery_evidence": "nhà cung cấp chưa báo đã giao trong 5 phút",
  "reason.delivery_bounced": "thư kiểm bị trả về",
  "reason.delivery_rejected": "thư kiểm bị từ chối",
  "reason.delivery_complained": "thư kiểm bị đánh dấu khiếu nại",
  "reason.no_request_id": "app không trả mã lượt gửi",
  "reason.app_not_sent": "app không gửi",
  "reason.app_unreachable": "không gọi được app",
  "reason.app_unauthorized": "app từ chối chữ ký",
  "reason.app_not_configured": "hub chưa có URL / secret của app",
  "reason.app_not_wired": "app chưa ốp « Gửi thử »",
  "reason.app_store_unavailable": "CSDL của app lỗi",
  "reason.app_invalid_response": "app trả lời sai hợp đồng",
  "reason.no_plug": "loại tích hợp chưa có cổng kiểm",
  revalidate: "Kiểm lại",
  remove: "Gỡ tuyến",
  removeTitle: "Gỡ tuyến {name}",
  removeEffect: "App thôi nhận tuyến này ở lượt đẩy kế tiếp. Tuyến chính không gỡ được — đặt tuyến khác làm chính trước.",
  removing: "Đang gỡ…",
  add: "Thêm / đổi tuyến",
  addPick: "Bộ thông số",
  addNone: "Không còn bộ email nào mở cho app này.",
  smtpHint: "SMTP không có bằng chứng giao — không chọn làm tuyến qua cổng kiểm được.",
  promote: "Kiểm & đặt làm chính",
  standby: "Kiểm & thêm dự phòng",
  promoteTitle: "Kiểm « {name} » rồi đặt làm tuyến chính",
  standbyTitle: "Kiểm « {name} » rồi thêm làm dự phòng",
  gateEffect: "Hub tiền kiểm tài khoản, đẩy tuyến xuống app ở trạng thái « chỉ để kiểm », app gửi THẬT một thư tới hộp thư kiểm, rồi chờ nhà cung cấp báo đã giao (≤ 5 phút). Đạt mới đổi — hỏng thì tuyến hiện tại giữ nguyên.",
  starting: "Đang bắt đầu…",
  policy: "Chính sách",
  "policy.failover": "Khi tuyến chính hỏng chắc chắn",
  "policy.failover.auto": "tự chuyển sang dự phòng « ấm »",
  "policy.failover.notify": "chỉ báo",
  "policy.failover.off": "không làm gì",
  "policy.cooldown": "Nghỉ giữa hai lần tự chuyển (phút)",
  "policy.warmHours": "Dự phòng « ấm » trong (giờ)",
  "policy.save": "Lưu chính sách",
  "policy.saving": "Đang lưu…",
  changes: "Nhật ký đổi tuyến",
  "changes.empty": "Chưa có lần đổi nào.",
  "signal.quota_exhausted": "hết hạn mức",
  "signal.auth_failed": "khoá bị từ chối",
  "signal.account_shutdown": "tài khoản bị khoá gửi",
  "signal.account_probation": "tài khoản đang bị xem xét",
  "signal.provider_outage": "nhà cung cấp không trả lời",
  "signal.ambiguous_outcomes": "nhiều lần gửi không rõ kết quả",
  "signal.failover": "đủ căn cứ tự chuyển",
  "change.failover": "tự chuyển sang dự phòng",
  "change.app_switch_accept": "hợp thức hoá lần app tự chuyển",
  "change.app_switch_revoke": "thu hồi lần app tự chuyển",
  "change.grandfather": "chuyển từ gán cũ",
  "change.stage": "bắt đầu cổng kiểm",
  "change.activate": "kích hoạt",
  "change.gate_failed": "cổng kiểm hỏng",
  "change.remove": "gỡ tuyến",
  "change.policy": "đổi chính sách",
  readOnly: "Bạn chỉ có quyền xem. Đổi tuyến cần quyền `hq.integrations.write`.",
  confirmType: "Gõ lại tên bộ « {name} » để xác nhận:",
  cancel: "Huỷ",
  failed: "Thao tác không thành công.",
  audit: "Thao tác được ghi nhật ký đổi tuyến.",
  manageAt: "Tuyến mail của app chọn ở trang Mail · {app}",
  routeOf: "{app}: {role}",
  "reason.sending_key_decrypt_failed": "hub không mở được khoá gửi của domain",
  "change.settings": "đổi địa chỉ gửi",
  "sender.label": "Gửi từ:",
  "sender.none": "chưa có địa chỉ gửi",
  "sender.replyToShort": "trả lời về {to}",
  "sender.from": "Địa chỉ gửi",
  "sender.fromName": "Tên người gửi (tuỳ chọn)",
  "sender.replyTo": "Địa chỉ nhận trả lời (tuỳ chọn)",
  "sender.hint": "Địa chỉ gửi là của app trên tuyến này, không của bộ — một bộ (tài khoản nhà cung cấp) dùng chung được cho nhiều app. Domain của địa chỉ phải đã xác minh trong tài khoản của bộ.",
  "sender.invalid": "Địa chỉ gửi / trả lời phải là email hợp lệ.",
  "sender.locked": "Bộ này đã là tuyến đang nhận thư của app, gửi từ {from} — cổng kiểm giữ địa chỉ đó; muốn đổi thì dùng « Đổi địa chỉ gửi » trên thẻ tuyến.",
  "sender.gateEffect": "Tuyến gửi từ {from}.",
  "sender.edit": "Đổi địa chỉ gửi",
  "sender.editHint": "Tuyến đang nhận thư: hub tiền kiểm địa chỉ mới trước (domain đã xác minh trong tài khoản, khoá gửi, webhook) — hỏng thì không đổi gì; đạt mới đổi, đẩy xuống app, rồi tự gửi thư kiểm qua địa chỉ mới.",
  "sender.save": "Lưu",
  "sender.saving": "Đang tiền kiểm…",
} as const;
